exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topics-wizard-type-selection-wrapper {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
